import { createApp } from "vue";
import SearchAllProducts from "./SearchAllProducts.vue";

createApp(SearchAllProducts).mount("#search-app-all-products");
